import { c as _c } from "react/compiler-runtime";
import { CommonSelectProps } from "../CommonSelect";
import CommonTabsTab from "./CommonTabsTab";
export default function CommonTabs(props) {
  const $ = _c(8);
  const {
    items,
    activeItem,
    setSelected
  } = props;
  let t0;
  if ($[0] !== items) {
    t0 = Object.values(items);
    $[0] = items;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== activeItem || $[3] !== items || $[4] !== props || $[5] !== setSelected || $[6] !== t0) {
    t1 = <div className="tw-p-1 tw-relative tw-ring-1 tw-ring-inset tw-bg-iron-950 tw-ring-iron-700 tw-inline-flex tw-rounded-lg tw-w-full sm:tw-w-auto tw-gap-x-1">{t0.map((item, i) => <CommonTabsTab key={item.key} item={item} itemIdx={i} totalItems={items.length} activeItem={activeItem} sortDirection={"sortDirection" in props ? props.sortDirection : undefined} setSelected={setSelected} isMobile={false} />)}</div>;
    $[2] = activeItem;
    $[3] = items;
    $[4] = props;
    $[5] = setSelected;
    $[6] = t0;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
}